import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import SmallLoader from "@shared/components/Atoms/Loading/SmallLoading";
import axios from "axios";
import { APP_NAME } from "@shared/util/brand";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const [step, setStep] = useState(1);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  const validatePassword = (newPassword, confirmPassword) => {
    const errors = [];

    if (newPassword !== confirmPassword) {
      errors.push("Passwords do not match.");
    }

    if (newPassword.length < 3) {
      errors.push("Password must be at least 3 characters long.");
    }

    // if (!/[a-z]/.test(newPassword)) {
    //   errors.push("Password must include at least one lowercase letter.");
    // }

    // if (!/[A-Z]/.test(newPassword)) {
    //   errors.push("Password must include at least one uppercase letter.");
    // }

    // if (!/[0-9]/.test(newPassword)) {
    //   errors.push("Password must include at least one number.");
    // }

    // if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
    //   errors.push("Password must include at least one special character.");
    // }

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    try {
      setError([]);
      const ers = validatePassword(newPassword, confirmPassword);
      if (!ers.isValid) {
        setError(ers.errors);
        return;
      }
      setLoading(true);
      const button = document.querySelector("#reset_btn");
      button.textContent = "Sending New Password ...";
      button.disabled = true;
      const res = await axios.post(
        `${import.meta.env.VITE_API_URL}/auth/reset-password`,
        {
          email,
          token,
          password: newPassword,
        }
      );
      // console.log({ res })
      if (res?.data) {
        setStep(2);
      }
    } catch (err) {
      console.error(err);
      setError([
        err?.response?.data?.error || "An error occurred. Please try again.",
      ]);
    } finally {
      setLoading(false);
      const button2 = document.querySelector("#reset_btn");
      button2.textContent = "Send Reset Link";
      button2.disabled = false;
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-br from-[#4A90E2] via-[#357ABD] to-[#2E5A87] p-5">
      <div className="text-white text-3xl font-semibold mt-5 mb-10">
        {APP_NAME}
      </div>

      <div className="bg-white rounded-2xl p-10 w-full max-w-md shadow-xl text-center">
        {step === 1 && (
          <div>
            <h1 className="text-2xl font-semibold text-[#2E5A87] mb-2">
              Reset Password
            </h1>
            <p className="text-gray-600 mb-6">
              Create a new password for your account
            </p>
            <form onSubmit={handleResetSubmit} className="text-left">
              <label className="block text-[#2E5A87] font-medium mb-2">
                New Password
              </label>
              <input
                type="password"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-4"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <label className="block text-[#2E5A87] font-medium mb-2">
                Confirm Password
              </label>
              <input
                type="password"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-4"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />

              {/* <div className="text-sm text-gray-600 bg-gray-100 p-4 rounded-lg mb-6">
                <strong>Password Requirements:</strong>
                <ul className="list-disc ml-6 mt-2">
                  <li>At least 8 characters long</li>
                  <li>Include uppercase and lowercase letters</li>
                  <li>Include at least one number</li>
                  <li>Include at least one special character</li>
                </ul>
              </div> */}
              <div className="my-4">
                {error.length > 0 &&
                  error.map((k, i) => (
                    <div
                      key={i}
                      className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm mb-2"
                    >
                      {k}
                    </div>
                  ))}
                {loading && <SmallLoader />}
              </div>
              <button
                type="submit"
                id="reset_btn"
                className="w-full py-4 bg-gradient-to-br from-[#4A90E2] via-[#357ABD] to-[#2E5A87] text-white font-semibold rounded-xl hover:shadow-lg transition mb-4"
              >
                Update Password
              </button>
            </form>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="w-20 h-20 mx-auto rounded-full bg-green-600 text-white flex items-center justify-center text-3xl mb-6">
              ✓
            </div>
            <h1 className="text-2xl font-semibold text-[#2E5A87] mb-2">
              Password Updated!
            </h1>
            <p className="text-gray-600 mb-6">
              Your password has been successfully changed
            </p>
            <p className="text-gray-600 mb-6">
              You can now sign in to your {APP_NAME} account with your new
              password.
            </p>
            <button
              onClick={() => { window.location.href = "/login"; }}
              className="w-full py-3 border-2 border-[#2E5A87] hover:bg-blue-500 text-[#2E5A87] font-medium rounded-xl hover:bg-[#2E5A87] hover:text-white transition"
            >
              Sign In Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
